/**
 * @generated SignedSource<<95149dc3940929f90b80909a023f8302>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeatureTemp_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeatureFlag_user">;
  readonly " $fragmentType": "FeatureTemp_user";
};
export type FeatureTemp_user$key = {
  readonly " $data"?: FeatureTemp_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeatureTemp_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeatureTemp_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeatureFlag_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a6395b19ff7660f5019948fe115b6754";

export default node;
